import { type ReactNode } from 'react'
import { Icon, type IconName } from '@/icons/Icon'

/**
 * 空状態 (Empty State) カード。design/js/components.jsx:155-161 を移植。
 * action は ReactNode (button 等の任意要素) を受ける。
 *
 * theme.css 側の `.empty` クラスをそのまま使う。
 */
export interface EmptyStateProps {
  icon?: IconName
  title: ReactNode
  sub?: ReactNode
  action?: ReactNode
}

export const EmptyState = ({ icon, title, sub, action }: EmptyStateProps): JSX.Element => (
  <div className="empty">
    <div className="ico-box">
      <Icon name={icon ?? 'info'} />
    </div>
    <h3>{title}</h3>
    {sub != null && <p>{sub}</p>}
    {action}
  </div>
)
